module.exports = __webpack_public_path__ + "media/icons/sqft-7c42336c.svg";